import React from "react";

import styles from "./gift-card-image.module.scss";

export interface Props {
    imageUrl: string;
}

const GiftCardImage: React.FC<Props> = ({ imageUrl }) => {
    return (
        <div className={styles.giftCardImageContainer}>
            <img className={styles.giftCardImage} src={imageUrl} />
        </div>
    );
};

export default GiftCardImage;
